import { Injectable } from '@angular/core';

@Injectable()
export class Config {
    cfg = {
        host: {
            env: 'APP_HOST',
            type: 'string',
            // default: 'iqnetwork.iqgeneral.com',
            // default:'192.168.1.121', 
            // default: 'dc87-103-99-148-80.ngrok.io',
            // default: 'betaconproperty.ducatus.com',
            default: 'liveconprop.ducatus.com',
            // default: '192.168.1.133',
            required: true
        },
        port: {
            env: 'APP_PORT',
            type: 'integer',
            default: '',
            // default: ':6868',  //sudo kill -9 $(sudo lsof -t -i:4200)
            // default: ':5110',
            required: true
        },
        protocol: {
            env: 'PROTOCOL',
            type: 'string',
            default: 'https',
            // default: 'http',
            required: true
        },
        env_mode: {
            env: 'NODE_ENV',
            type: 'string',
            default: 'development',
            values: ['development', 'production', 'test'],
            required: true
        },
        baseUrlProd: {
            env: 'BASE_URL',
            type: 'string',
            default: 'https://localhost/property',
            required: true
        },
        buildSource: {
            env: 'BUILD_SOURCE',
            type: 'string',
            default: false,
            required: true
        },
    }
}
